<div
  *ngIf="defaultCard"
  class="select-cards"
  role="button"
  (click)="navigateToPaymentMethods()"
>
  <img src="../../../assets/icon/payment/visa.png" alt="visa icon" />
  <span>{{ defaultCard }}</span>
</div>
